import { Action } from "redux";
import AppAction from "@my-dld/actions";
import {
	TCCommercialInfo,
	TCContractInfo,
	TCCoOccupantsInfo,
	TCDocumentInfo,
	TCRemarksInfo,
	TCTerminateInfo,
	TenancyContractResponse,
	Tenant,
	TenantContractInfo
} from "@eres/ejari-api/Entity/tenant";
import { TenancyContactAction } from "../constants";
import { EjariProperty } from "@eres/ejari-api/Entity";
import { MoveOut } from "@eres/ejari-api/Entity/contract";

export interface TenantContractDataState {
	AllowedCoTenants?: number;
	property?: EjariProperty;
	action?: TenancyContactAction;
	contractInfo?: TCContractInfo;
	isCommercial?: boolean;
	documentInfo?: TCDocumentInfo;
	remarksInfo?: TCRemarksInfo;
	commercialInfo?: TCCommercialInfo;
	coOccupantsInfo?: TCCoOccupantsInfo;
	terminateInfo?: TCTerminateInfo;
	tenant?: Tenant;
	tempContractId?: number;
	contract?: TenantContractInfo;
	canResubmit: boolean;
	actionDone: boolean;
	contractResp?: TenancyContractResponse;
	hazardIds?: number[];
	moveOut?: MoveOut;
}

export const defaultState: TenantContractDataState = {
	canResubmit: false,
	actionDone: false,
};

export enum TenantContractDataAction {
	TENANT_CONTRACT_CLEAR_DATA = "TENANT_CONTRACT_CLEAR_DATA",
	TENANT_CONTRACT_UPDATE_STATE = "TENANT_CONTRACT_UPDATE_STATE",
}

export type TenantContractAction = Action<AppAction.USER_LOGGED_OUT> |
	Action<TenantContractDataAction.TENANT_CONTRACT_CLEAR_DATA> |
	Action<TenantContractDataAction.TENANT_CONTRACT_UPDATE_STATE> & { payload?: Partial<TenantContractDataState> };

export function TenantContractDataReducer( state = defaultState, action: TenantContractAction ) {
	switch ( action.type ) {
		case TenantContractDataAction.TENANT_CONTRACT_CLEAR_DATA:
			return {
				...defaultState
			};

		case TenantContractDataAction.TENANT_CONTRACT_UPDATE_STATE:
			return {
				...state,
				...action.payload,
			};

		case AppAction.USER_LOGGED_OUT:
			return { ...defaultState };

		default:
			return state;
	}
}
